export default __webpack_public_path__ + "static/media/fondoRegister.83b8914f.jpeg";